import { Clipboard } from '@angular/cdk/clipboard';
import { Injectable } from '@angular/core';
import { NGXLogger as LoggerService } from "ngx-logger";

@Injectable({
    providedIn: 'root'
})
/**
 * The one copy implementation of the app (workorder poll-scoped access 1.8): the surfaces show
 * "url copied" only when `copy` resolves true. Writing to the clipboard is allowed only within a user
 * gesture - after an `await` (key resolution, dialog opened from an async handler) it fails, in Safari
 * that is the normal case. A failure is no error and gets no message, only a log line.
 */
export class ClipboardService {

    constructor(
        private clipboard: Clipboard,
        private logger: LoggerService,
    ) { }

    /** copies `text`; true only when it really reached the clipboard (clipboard API, CDK fallback) */
    public async copy(text: string): Promise<boolean> {
        if (!text) {
            return false;
        }
        // never the text itself: the copied links carry keys
        if (navigator.clipboard?.writeText) {
            try {
                await navigator.clipboard.writeText(text);
                this.logger.log('ClipboardService: copied (clipboard api)');
                return true;
            } catch (error) {
                this.logger.log('ClipboardService: clipboard api refused, trying the fallback', (error as Error)?.name);
            }
        }
        const isCopied = this.clipboard.copy(text);
        this.logger.log('ClipboardService: fallback copy', isCopied ? 'succeeded' : 'failed');
        return isCopied;
    }
}
